import React, {
  useEffect,
  useState,
} from "react";

const Holidays = () => {

  const [data, setData] =
    useState([]);

  useEffect(() => {

    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/holidays/all"
    )
      .then((res) => res.json())
      .then((res) => setData(res));

  }, []);

  return (

    <div className="bg-[#ECE9D8] min-h-screen py-10">

      <div className="max-w-6xl mx-auto">

        {
          data.map((item) => (

            <div
              key={item.id}
              className="mb-14 border-4 border-orange-500 bg-white"
            >

              <div className="bg-[#F7D08A] text-center py-3">

                <h2 className="text-5xl font-bold text-[#0A3470] uppercase">

                  {item.title}

                </h2>

              </div>

              <div className="p-2">

                {
                  item.type === "image"
                  ? (

                    <img
                      src={`https://stjosephweb.ilakshyaerp.in/uploads/holidays/${item.file}`}
                      alt=""
                      className="w-full"
                    />

                  )
                  : (

                    <iframe
                      src={`https://stjosephweb.ilakshyaerp.in/uploads/holidays/${item.file}`}
                      title=""
                      className="w-full h-[900px]"
                    />

                  )
                }

              </div>

            </div>

          ))
        }

      </div>

    </div>
  );
};

export default Holidays;